import { FC } from 'react';
import Card from '@/Components/organisms/Card';
import * as helper from './ErrorSection.helper';
import { Props } from './ErrorSection.type';
import './ErrorSection.scss';
import { useTranslation } from 'react-i18next';

const ErrorSection: FC<Props> = props => {
  const { t } = useTranslation();

  return (
    <div className="error-section">
      <div className="logo" />
      <Card
        type="error"
        titleCard={t(helper.defineTitle(props.status, props.message))}
        subtitleCard={t(helper.defineTexts(props.status, props.message))}
        errorStatus={props.status}
        imgCard={helper.setErrorCardImg(props.status, props.message)}
      />
    </div>
  );
};

export { ErrorSection };
